import { createContext, useState } from 'react'

import { IInvoiceCompleteResponseDTO } from '../../sdk/invoices/invoice.types'
import { ItemResponseDTO } from '../../sdk/items/items.types'
import { sdk } from '../../services/sdk'

interface ProviderItemsDataContext {
  pendingItems: ItemResponseDTO[]
  pendingItemsCount: number

  completeInvoices: IInvoiceCompleteResponseDTO[]
  completeInvoicesCount: number

  actions: {
    fetchPendingItems: (page?: number, search?: string) => void

    fetchCompleteInvoices: (page: number) => void
    fetchCountCompleteInvoices: () => void
    searchCompleteInvoice: (code: string) => void
  }
}

interface ProviderItemsProviderProps {
  children: React.ReactNode
}

export const ProviderItemsContext = createContext(
  {} as ProviderItemsDataContext,
)

export function ProviderItemsProvider(props: ProviderItemsProviderProps) {
  const [pendingItems, setPendingItems] = useState<ItemResponseDTO[]>([])
  const [pendingItemsCount, setPendingItemsCount] = useState<number>(0)

  const [completeInvoices, setCompleteInvoices] = useState<
    IInvoiceCompleteResponseDTO[]
  >([])
  const [completeInvoicesCount, setCompleteInvoicesCount] = useState<number>(0)

  const fetchPendingItems = async (page?: number, search?: string) => {
    const _response = await sdk.items.getPendingItems(page, search)

    setPendingItems(_response.data)
    setPendingItemsCount(_response.count)
  }

  const fetchCompleteInvoices = async (page: number) => {
    try {
      const response = await sdk.invoices.getComplete({ page, limit: 12 })

      const mapped = Object.keys(response).map(
        (key) =>
          ({
            ...response[key as any],
            code: key,
          }) as IInvoiceCompleteResponseDTO,
      )

      setCompleteInvoices(mapped)
    } catch (err) {
      setCompleteInvoices([])
      setCompleteInvoicesCount(0)
    }
  }

  const fetchCountCompleteInvoices = async () => {
    const response = await sdk.invoices.getCompleteCount()
    setCompleteInvoicesCount(response.count)
  }

  const searchCompleteInvoice = async (code: string) => {
    if (!code.trim().length) {
      fetchCompleteInvoices(1)
      fetchCountCompleteInvoices()
      return
    }

    try {
      const response = await sdk.invoices.getCompleteInvoice(code)
      setCompleteInvoices([response])
      setCompleteInvoicesCount(1)
    } catch (err) {
      setCompleteInvoices([])
      setCompleteInvoicesCount(0)
    }
  }

  return (
    <ProviderItemsContext.Provider
      value={{
        pendingItems,
        pendingItemsCount,
        completeInvoices,
        completeInvoicesCount,

        actions: {
          fetchPendingItems,

          fetchCompleteInvoices,
          fetchCountCompleteInvoices,
          searchCompleteInvoice,
        },
      }}
    >
      {props.children}
    </ProviderItemsContext.Provider>
  )
}
